import { Select, SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

import { type SenderChoiceControl } from './useSenderChoice';

/**
 * Names who the Account's email is sent as, as a picker where more than one
 * sender is available. Owns that branch, and the wait for the sender to load,
 * so a form does not have to re-derive either.
 *
 * Picking here changes every later send that offers the choice, because the
 * choice is the user's own remembered preference rather than a property of the
 * document being sent.
 */
const SenderChoiceField: FC<SenderChoiceControl> = (props) => {
  const { options, canChoose, selected, onChoose } = props;

  if (!selected) return <SkeletonLoader.Text className="w-2/3" />;

  if (!canChoose) return <>{selected.sender}</>;

  return (
    <Select
      aria-label="Send from"
      options={options.map(({ key, label }) => ({ label, value: key }))}
      value={selected.key}
      onChange={(key) => onChoose(key)}
      multiple={false}
    />
  );
};

export default SenderChoiceField;
